const variables = {
  // defaultURL: '',
  // defaultURL: 'http://localhost:8789',
  defaultURL: 'https://admin.refund.tmssite.com',
  danger: 'danger',
  warning: 'warning',
  success: 'success',
  server_error : 'Error'
};
export { variables };
//# sourceMappingURL=systemConstants.js.map
